<div>
    <ul>
        <li *ngFor="let note of notes">
            {{ note.note }}
            <ifc-release-note [notes]="note.subnotes"></ifc-release-note>
        </li>
    </ul>
</div>